import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  IAppSession,
  IAppUser,
} from '../app.store.interface';
import { AuthService } from '@app/core/services/auth.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { IUser } from 'src/app/shared/src/lib/interfaces/user.interface';

const DEFAULT_MSG_PERIMSSION =
  'No tiene permisos para realizar acciones en esta opción';
const jwtHelper = new JwtHelperService();
const SIGO_SESSION_KEY = "SIGO_SESION_ACTUAL";

export class AppSessionAction {
  constructor(
    private getState: () => IAppSession,
    private setState: (newState: IAppSession) => void,
  ) { }

  //=======================================================
  // ACCIONES QUE MODIFICAN EL ESTADO
  //=======================================================

  restablecerSesionDeLocalStorage = () => {
    const token = localStorage.getItem(SIGO_SESSION_KEY);
    this.setSesion(token);
  }

  login = (token: string) => {
    this.setSesion(token);
    localStorage.setItem(SIGO_SESSION_KEY, token);
  }

  private setSesion = (token: string) => {

    let sesion: IAppUser = jwtHelper.decodeToken(token);

    let displayUser: IUser = {
      fullName: sesion.Name,
      email: sesion.email,
      lastSession: null,
      avatarText: sesion.Name.substr(0, 1),
      rolName: null,
      defaultRol: {
        NOMBRE_ROL: ''
      },
      roles: null,
      ttipoUsuario: sesion.TTipoUsuario
    }

    this.setState({
      ...this.getState(),
      token: token,
      user: sesion,
      isLoading: true,
      displayUser: displayUser
    });
  }

  logout = () => {
    this.setState({
      ...this.getState(),
      isLoggedIn: false,
      user: null,
      token: null
    });

    localStorage.removeItem(SIGO_SESSION_KEY);
  };

  getUserSesion = (): IAppUser => {
    return this.getState().user;
  }

  esSesionValida = () => {
    const token = localStorage.getItem(SIGO_SESSION_KEY);

    return !jwtHelper.isTokenExpired(token);
  }

  //-----------------------------------------
  setSessionFromStorage = (session: IAppSession) => {
    this.setState({ ...session, fromStorage: true });
  };

  setNewToken = (token: string) => {
    this.setState({ ...this.getState(), token });
    //this.localStorage.set(SIU_SESSION_KEY, this.getState());
  };

  setAuthToken = (token: string, returnUrl: string) => {
    this.setState({ ...this.getState(), token: token, returnUrl: returnUrl });
  };

  loginBegin = () => {
    this.setState({ ...this.getState(), isLoading: true, loginError: false });
  };

  loginCompletar = () => {
    let state = this.getState();

    this.setState({
      ...state,
      isLoading: false,
      isLoggedIn: true
    });

  }

  loginSuccess = () => {
    this.setState({
      ...this.getState(),
      isLoading: false,
      isLoggedIn: true,
      //user
    });

    // this.localStorage.set(SIU_SESSION_KEY, this.getState());
  };

  loginError = () => {
    this.setState({ ...this.getState(), isLoading: false, loginError: true });
  };

  setSessionExpired = () => {
    this.setState({ ...this.getState(), sessionExpired: true });
  };

  getUser = (): IAppUser => {
    const state = this.getState();

    return state.user;
  };
}



// import {
//   IAppSession,
//   IAppUser,
//   ISesion,
//   ISesionSTS,
// } from "./../app.store.interface";
// import { IUser } from "src/app/shared/src/lib/interfaces/user.interface";
// import { AuthService } from "@app/core/services/auth.service";

// export class AppSessionAction {
//   constructor(
//     private getState: () => IAppSession,
//     private setState: (newState: IAppSession) => void,
//     private authService: AuthService
//   ) {}

//   //=======================================================
//   // ACCIONES QUE MODIFICAN EL ESTADO
//   //=======================================================
//   setSesion = (sesion: ISesion) => {
//     const userApp = sesion.appUser;

//     let displayUser: IUser = {
//       fullName: userApp.Name,
//       email: userApp.email,
//       phone: userApp.telefono,
//       lastSession: null,
//       avatarText: userApp.Name.substring(0, 1),
//       rolName: null,
//       defaultRol: {
//         NOMBRE_ROL: "",
//       },
//       roles: null,
//     };

//     this.setState({
//       ...this.getState(),
//       user: userApp,
//       sessionSTS: sesion.sesionSTS,
//       isLoading: true,
//       displayUser: displayUser,
//     });
//   };

//   logout = () => {
//     this.setState({
//       ...this.getState(),
//       isLoggedIn: false,
//       user: null,
//       displayUser: null,
//       sessionSTS: null,
//       token: null,
//     });
//   };

//   getUserSesion = (): IAppUser => {
//     return this.getState().user;
//   };

//   getSesionSTS = (): ISesionSTS => {
//     return this.getState().sessionSTS;
//   };

//   esSesionValida = async () => {
//     let res = await this.authService.esSesionValida();
//     return res;
//   };

//   loginBegin = () => {
//     this.setState({ ...this.getState(), isLoading: true, loginError: false });
//   };

//   loginCompletar = () => {
//     this.setState({
//       ...this.getState(),
//       isLoading: false,
//       isLoggedIn: true,
//     });
//   };

//   loginError = () => {
//     this.setState({ ...this.getState(), isLoading: false, loginError: true });
//   };

//   /**
//    * DEPRECATED
//    */
//   getUser = (): IAppUser => {
//     const state = this.getState();

//     return state.user;
//   };
// }
